import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../lib/auth';
import { Button } from '../components/ui/button';
import { Input } from '../components/ui/input';
import { Label } from '../components/ui/label';
import { toast } from '../lib/aiToast';

export default function Register() {
  const { register } = useAuth();
  const nav = useNavigate();
  const [form, setForm] = useState({ name: '', email: '', password: '', practiceName: '' });
  const [submitting, setSubmitting] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setSubmitting(true);
    try {
      await register(form);
      toast.success('Workspace created');
      nav('/app');
    } catch (err) {
      toast.error(err.message);
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="min-h-screen grid md:grid-cols-2">
      <div className="hidden md:flex dh-hero p-12 flex-col justify-between">
        <Link to="/" className="flex items-center gap-2">
          <div className="h-8 w-8 rounded-lg bg-brand-600 text-white flex items-center justify-center font-bold">D</div>
          <div className="leading-tight">
            <div className="text-sm font-semibold text-slate-900">Due Health</div>
            <div className="text-[10px] uppercase tracking-wider text-brand-500 font-medium">Eligibility AI</div>
          </div>
        </Link>
        <div>
          <h2 className="text-3xl font-semibold text-slate-900 max-w-md">Create your practice workspace.</h2>
          <p className="mt-3 text-slate-600 max-w-md">Each tenant gets isolated data, an agent audit trail, and per-practice contracted-plan intelligence.</p>
        </div>
        <div className="text-xs text-slate-500">Multi-tenant · RBAC enforced at the API layer</div>
      </div>

      <div className="p-8 md:p-12 flex items-center justify-center bg-white">
        <div className="w-full max-w-sm">
          <h1 className="text-2xl font-semibold text-slate-900">Create workspace</h1>
          <p className="mt-1 text-sm text-slate-500">You’ll be the practice admin.</p>
          <form onSubmit={submit} className="mt-8 space-y-4">
            <div><Label htmlFor="pname">Practice name</Label><Input id="pname" value={form.practiceName} onChange={(e) => setForm({ ...form, practiceName: e.target.value })} required className="mt-1.5" placeholder="e.g. Pacific Dermatology Group" /></div>
            <div><Label htmlFor="name">Your name</Label><Input id="name" value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} required className="mt-1.5" /></div>
            <div><Label htmlFor="email">Email</Label><Input id="email" type="email" value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} required className="mt-1.5" /></div>
            <div><Label htmlFor="pw">Password</Label><Input id="pw" type="password" value={form.password} onChange={(e) => setForm({ ...form, password: e.target.value })} required minLength={8} className="mt-1.5" /></div>
            <Button type="submit" className="w-full bg-brand-600 hover:bg-brand-700 text-white" disabled={submitting}>{submitting ? 'Creating…' : 'Create workspace'}</Button>
          </form>
          <div className="mt-6 text-sm text-slate-600 text-center">
            Already have an account? <Link to="/login" className="text-brand-600 font-medium hover:underline">Sign in</Link>
          </div>
        </div>
      </div>
    </div>
  );
}
